"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privateRouter = exports.publicRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const pathPrefix = '/scripts';
const c = (0, core_1.initContract)();
const publicRoutes = c.router({
    getLines: {
        method: 'GET',
        path: '/:id/lines',
        pathParams: zod_1.z.object({
            id: schemas_1.Uuid,
        }),
        responses: {
            200: zod_1.z.object({ lines: zod_1.z.array(schemas_1.ScriptLineData) }),
        },
        summary: 'Get an array of line data for the script',
    },
    getCompiledInk: {
        method: 'GET',
        path: '/:id/inkjson',
        pathParams: zod_1.z.object({
            id: schemas_1.Uuid,
        }),
        responses: {
            200: schemas_1.InkCompileResult,
        },
        summary: 'Compile a standalone Ink source file',
    },
    getFDX: {
        method: 'GET',
        path: '/:id/fdx',
        pathParams: zod_1.z.object({
            id: schemas_1.Uuid,
        }),
        responses: {
            200: schemas_1.FdxExportResult,
        },
        summary: 'Export script content in FDX format',
    },
});
const privateRoutes = c.router({});
const allRoutes = Object.assign(Object.assign({}, privateRoutes), publicRoutes);
exports.publicRouter = c.router(publicRoutes, { pathPrefix });
exports.privateRouter = c.router(allRoutes, { pathPrefix });
